import React from "react";
import styles from "../CheckoutSection.module.scss";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";

/**
 * Component for selecting payment method during checkout
 */
const PaymentMethodSelector = ({ selectedMethod, onChange }) => {
	const handleMethodSelect = (method) => {
		onChange({ target: { name: "paymentMethod", value: method } });
	};

	return (
		<div className={`${styles.paymentMethods} mb-4`}>
			<div className="row g-2">
				<div className="col-4">
					<div
						className={`${styles.paymentMethod} p-3 ${selectedMethod === 'invoice' ? styles.active : ''}`}
						onClick={() => handleMethodSelect("invoice")}
						role="button"
						tabIndex={0}
						aria-pressed={selectedMethod === "invoice"}
						aria-label="Per Rechnung bezahlen"
						title="Per Rechnung bezahlen"
						data-payment-method="invoice">
						<DynamicFontAwesomeIcon 
							iconName="fileInvoice" 
							aria-hidden="true" 
						/>
						<span>Rechnung</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PaymentMethodSelector;
